export default __webpack_public_path__ + "static/media/Print-12.3ab869cc.svg";